{
  "headings": {
    "question": "Ask about housing",
    "housingQuestion": "Housing-related question",
    "questionPreview": "Question preview",
    "questionDetail": "Question details",
    "preview": "Preview",
    "success": "Question"
  },
  "texts": {
    "instructions": "Do you need help with housing-related matters?\n\nSend us a message using the form below — we will contact you as soon as possible.\n\nIn urgent cases, please contact our specialists through the Contact Information page.",
    "success": "Your question has been sent. We will answer it via email.",
    "expectsResponseInstructions": "Do you want a response to your feedback? If you wish to receive a response, please mention it in your message. This way, we can ensure that we get back to you as smoothly as possible.",
    "contactDetailsUpdateInstructions": "If necessary, you can update your contact details here. You can also edit them through the My Information page."
  },
  "placeholders": {
    "title": "Title",
    "description": "Describe your question in more detail"
  },
  "alt": {
    "successIllustration": "Thank you illustration"
  },
  "labels": {
    "title": "Title",
    "description": "Description",
    "files": "Attachments",
    "email": "Email",
    "phoneNumber": "Phone",
    "expectsResponse": "I want to be contacted"
  },
  "actions": {
    "back": "Back",
    "resetForm": "Clear form",
    "sendForm": "Send question",
    "preview": "Preview",
    "edit": "Edit",
    "submit": "Submit"
  },
  "errors": {
    "submitError": "Error sending the question. If the problem persists, please contact customer service.",
    "serviceUnavailable": "Question creation is not available at the moment. Please try again later.",
    "noQuestionFound": "No question found.",
    "missingUserPhoneNumber": {
      "title": "Unfortunately, question creation failed",
      "message": "To continue creating a question, please add your phone number to your profile."
    }
  }
}
